import { compose, lifecycle, withHandlers } from 'recompose';
import { addProps, renderNothingIfPropFalsy } from 'utils/recompose';
import { addIntlProps } from 'utils/recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  fetchTotalCartQuantity,
  fetchCart,
  fetchAdditionalCart,
} from 'reducers/cart/actions';
import { fetchSeriesAllocation } from 'reducers/series/actions';
import { fetchDashboard } from 'reducers/dashboard/actions';
import { seriesIds } from 'reducers/inCartSeries/selectors';
import { remaining } from 'reducers/cart/selectors';
import { cartLoading } from 'reducers/loading/selectors';
import { cartSubmissionLoading } from 'reducers/loading/selectors';
import combineSelectors from 'utils/combineSelectors';
import messages from './messages';
import { initialCartLoadSeriesPageSize } from 'constants/values';

const mapStateToProps = combineSelectors({
  seriesIds,
  cartSubmissionLoading,
  remaining,
  cartLoading,
});

const mapDispatchToProps = {
  fetchTotalCartQuantity,
  fetchSeriesAllocation,
  fetchDashboard,
  fetchCart,
  fetchAdditionalCart,
};

export const cartLoaded = ({ cartLoading }) => !cartLoading;

export const cartIsEmpty = ({ seriesIds }) => !Boolean(seriesIds.length);

export const hasRemaining = ({ remaining }) => remaining > 0;

export const moreCart = ({
  seriesIds,
  fetchAdditionalCart,
  hasRemaining,
}) => () => {
  if (hasRemaining) {
    fetchAdditionalCart({ seriesIds });
  }
};

export function componentDidMount() {
  this.props.fetchCart({
    seriesIds: [],
    seriesPageSize: initialCartLoadSeriesPageSize,
  });
  this.props.fetchSeriesAllocation();
  this.props.fetchTotalCartQuantity();
  this.props.fetchDashboard();
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['submitting', 'loading'],
  }),
  addProps({ hasRemaining }),
  withHandlers({
    moreCart,
  }),
  lifecycle({ componentDidMount }),
  addProps({ cartLoaded, cartIsEmpty, moreCart }),
  renderNothingIfPropFalsy('cartLoaded'),
);
